"use client";

import { useState, useEffect } from "react";
import { getCurrentLanguage, msg } from "@/utils/multilingual";
import { USER_LANGUAGES } from "@/config/enums/user.enum";

// React hook for language state that triggers re-renders
export const useLanguage = () => {
  // Keep first render deterministic for SSR/client hydration.
  const [language, setLanguage] = useState(USER_LANGUAGES.ENGLISH);

  useEffect(() => {
    // Set initial language
    setLanguage(getCurrentLanguage());

    // Listen for language changes
    const handleLanguageChange = (event) => {
      setLanguage(event.detail);
    };

    window.addEventListener("languagechange", handleLanguageChange);

    // Also listen to storage events in case language is changed in another tab
    const handleStorageChange = (event) => {
      if (event.key === "language") {
        const newLang = event.newValue || USER_LANGUAGES.ENGLISH;
        setLanguage(newLang);
        window.dispatchEvent(
          new CustomEvent("languagechange", { detail: newLang }),
        );
      }
    };

    window.addEventListener("storage", handleStorageChange);

    return () => {
      window.removeEventListener("languagechange", handleLanguageChange);
      window.removeEventListener("storage", handleStorageChange);
    };
  }, []);

  return language;
};

// React hook for translations that automatically re-renders on language change
export const useTranslation = () => {
  // const language = "en";
  const language = useLanguage(); //!

  const t = (key, vars) => {
    return msg(key, language, vars);
  };

  return { t, language };
};
